import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Brand, useAccount} from "@mytour/platform";
import {useState} from "react";
import {Trans as Translate} from "react-i18next";
import {Collapse, Nav, Navbar, NavbarToggler} from "reactstrap";
import "../menus/header.scss";
import {MenuItem} from "../menus/MenuItem";
import {NavDropdown} from "../menus/NavDropdown";

export function WorkerHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const {account} = useAccount();
  const login = account?.login;
  let loginDisplay = login;
  if (login && login.length > 10) {
    loginDisplay = `${login.substring(0, 8)}…`;
  }
  return (
    <div id="app-header">
      <Navbar dark expand="md" fixed="top" className="jh-navbar">
        <Brand />
        <NavbarToggler aria-label="Menu" onClick={toggleMenu}>
          <FontAwesomeIcon icon="cog" />
        </NavbarToggler>
        <Collapse isOpen={menuOpen} navbar>
          <Nav id="header-tabs" className="ml-auto" navbar>
            <NavDropdown icon="user" name={loginDisplay} id="account-menu" data-cy="accountMenu">
              <MenuItem icon="sign-out-alt" to="/logout" data-cy="logout">
                <Translate i18nKey="global.menu.account.logout">Sign out</Translate>
              </MenuItem>
            </NavDropdown>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );

  function toggleMenu() {
    setMenuOpen(!menuOpen);
  }
}
